import { Events, Linked } from "@type-r/models";
import { useEvent, useIO, useLinked } from "@type-r/react";
import { RelationshipModel } from "api/relationship";
import { Column, Columns, Flex, FormInput, FormSelect, Loading, Option, ReadOnly, Toolbar } from "lqx-react/lib";
import React from "react";
import { CpSaveButton } from "../common/api";

const toleranceTypes = ['None', 'Amount', 'Percent'];

export const CpAllowableDiscountsAndTolerances = ({ $selected, canEdit }: {
    $selected: RelationshipModel,
    canEdit: Boolean
}) => {
    const discount = $selected.cpDiscount;

    const $toleranceType = useLinked<string>(null);
    const $reconciliationToleranceType = useLinked<string>(null);

    const loadData = async () => {
        await $selected.cpDiscount.fetch();

        postLoad($toleranceType, $selected.cpDiscount.toleranceAmount, $selected.cpDiscount.tolerancePercent);
        postLoad($reconciliationToleranceType, $selected.cpDiscount.reconciliationToleranceAmount, $selected.cpDiscount.reconciliationTolerancePercent);
    }
    const isReady = useIO(loadData, []);

    useEvent(Events, "cpImport:done", loadData);

    const save = async () => {
        preSave($toleranceType.value, $selected.cpDiscount.$.toleranceAmount, $selected.cpDiscount.$.tolerancePercent);
        preSave($reconciliationToleranceType.value, $selected.cpDiscount.$.reconciliationToleranceAmount, $selected.cpDiscount.$.reconciliationTolerancePercent);

        await $selected.cpDiscount.save();
    }

    return (
        isReady ? <>
            <ReadOnly.Provider value={!canEdit}>
                <Columns>
                    <Column>
                        <Tolerance
                            toleranceName="Recommendation"
                            $toleranceType={ $toleranceType }
                            $toleranceAmount={ $selected.cpDiscount.$.toleranceAmount }
                            $tolerancePercent={ $selected.cpDiscount.$.tolerancePercent }
                        />
                    </Column>

                    <Column>
                        <Tolerance
                                toleranceName="Reconciliation"
                                $toleranceType={ $reconciliationToleranceType }
                                $toleranceAmount={ $selected.cpDiscount.$.reconciliationToleranceAmount }
                                $tolerancePercent={ $selected.cpDiscount.$.reconciliationTolerancePercent }
                            />
                    </Column>
                </Columns>
            </ReadOnly.Provider>
            <Toolbar>
                <Flex grow />
                {canEdit && <CpSaveButton onClick={save} isDisabled={!discount.isValid()} label={'Save allowable discount and tolerances?'} />}
            </Toolbar>
        </> : < Loading />
    );
}

const postLoad = ($toleranceType: Linked<string>, toleranceAmount: number, tolerancePercent: number) => {
    if (toleranceAmount) {
        $toleranceType.set('amount');
    } else if (tolerancePercent) {
        $toleranceType.set('percent');
    }
};

const preSave = (toleranceType: string, $toleranceAmount: Linked<number>, $tolerancePercent: Linked<number>) => {
    if (toleranceType !== 'amount') {
        $toleranceAmount.null();
    }
    if (toleranceType !== 'percent') {
        $tolerancePercent.null();
    }
};

const Tolerance = ({$toleranceType, $toleranceAmount, $tolerancePercent, toleranceName}
    : {$toleranceType: Linked<string>, $toleranceAmount: Linked<number>, $tolerancePercent: Linked<number>, toleranceName: string}) =>
    (<>
        <FormSelect label={toleranceName + " tolerance type"} $value={$toleranceType}>
            {toleranceTypes.map(f => <Option key={f} value={f.toLowerCase()}>{f}</Option>)}
        </FormSelect>
        {$toleranceType && $toleranceType.value === 'amount' && <FormInput label={toleranceName + " tolerance amount"} $value={$toleranceAmount} number />}
        {$toleranceType && $toleranceType.value === 'percent' && <FormInput label={toleranceName + " tolerance percent"} $value={$tolerancePercent} number />}
    </>);